import { action } from 'satcheljs';
export var userMailInteractionAction = action('USERMAIL_INTERACTION', function (interactionType, instrumentationContexts) {
    return {
        interactionType: interactionType,
        instrumentationContexts: instrumentationContexts,
    };
});
export default function (interactionType, instrumentationContexts) {
    if (instrumentationContexts && instrumentationContexts.length > 0) {
        userMailInteractionAction(interactionType, instrumentationContexts);
    }
}
//# sourceMappingURL=userMailInteractionAction.js.map